export default import.meta.ROLLDOWN_FILE_URL_rKrqUHGCQUyQJxsjUC$15w